module.exports = __webpack_public_path__ + "img/invoice.ecc9deb6.png";